module.exports = "<breadcrumbs> <a href=#!>Top</a> <a href=#!>Middle</a> <a href=#!>Bottom</a> </breadcrumbs>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/breadcrumbs/breadcrumbs-with-slot.vue
 ** module id = 144
 ** module chunks = 0
 **/